import personalizeService from '../services/rbata.personalizeService';
import urlService from '../services/rbata.urlService';
import urlUtils from '../services/rbata.urlService';
import logger from '../utils/rbata.logger';
import plpService from '../services/rbata.plpService';
import spinner from '../utils/rbata.spinner';
import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';
import startCloudinaryResponsive from '../utils/rbata.cloudinary';
import productTileSlider from '../plp/rbata.tileSlider';
import productTileSwatches from '../plp/rbata.tileSwatches';
import facetSelection from '../plp/rbata.facet-selection';

const employee = {
    fetchEmployeeGroups() {
        personalizeService.getPersonalizedData().then((data) => {
                    const userGroups = data.userGroups || [];
                    this.unveilEmployeeSections(userGroups);
                }, (jqXHR) => {
                    logger.error(`employee.fetchEmployeeGroups, code: ${jqXHR.status}`);
                }
        )
    },
    unveilEmployeeSections(userGroups) {
        if (userGroups.length > 1) {
            userGroups.forEach((element) => {
                $(`.grp-${element}`).removeClass('d-none');
            })
        }
    },
    loadEmployeePDPRequest(baseID, variantCode) {
        return $.ajax({
            url:    `${urlService.getBaseUrl()}restrictedpdp/${baseID}/?vc=${variantCode}`,
            method: 'GET',
            cache:  false
        });
    }
};

$(() => {
    if ($('#page-header').length) {
        employee.fetchEmployeeGroups();
    }
});

export default employee;
